import { type IGroupOrLabel, type ILogbook } from "src/interfaces";
import { v4 as uuidv4 } from "uuid";

export const mapOrganize = (data: any) => {
  const active = data.data.logbooks.active as Array<ILogbook | IGroupOrLabel>;

  let logbooks: ILogbook[] = [];
  const groups: IGroupOrLabel[] = [];
  active.forEach(el => {
    if ("group" in el) {
      const element = el;
      groups.unshift({ ...element, groupId: uuidv4() });
      logbooks = [...element.logbooks, ...logbooks];
    } else {
      logbooks.push(el);
    }
  });

  return { logbooks, groups };
};

export const mapToRequest = (groups: IGroupOrLabel[], logbooks: ILogbook[]) => {
  let usedLogbooks: string[] = [];

  const mappedGroups = groups.map(group => {
    const logbooks = group.logbooks.map(log => log.lbid);
    usedLogbooks = [...usedLogbooks, ...logbooks];
    return {
      group: group.group,
      color: group.color,
      logbooks,
    };
  });

  const unusedLogbooks = logbooks
    .map(log => log.lbid)
    .filter(log => !usedLogbooks.includes(log));

  return [...unusedLogbooks, ...mappedGroups];
};
